import { IconType } from 'react-icons'
import { FiAlertCircle, FiCheckCircle, FiInfo, FiXCircle } from 'react-icons/fi'
import { toast, ToastOptions } from 'react-toastify'

// Definizione dei tipi di toast
export type ToastType = 'info' | 'success' | 'warning' | 'error' | 'validationError'

// Interfaccia per le opzioni del toast
interface ToastConfig extends Omit<ToastOptions, 'type'> {
  message?: string
  title?: string
  type?: ToastType
  icon?: IconType
  duration?: number
  description?: React.ReactNode
  showIcon?: boolean
}

// Mappa delle icone predefinite per tipo di toast
const defaultIcons: Record<ToastType, IconType> = {
  info: FiInfo,
  success: FiCheckCircle,
  warning: FiAlertCircle,
  error: FiXCircle,
  validationError: FiAlertCircle,
}

// Funzione per mostrare il toast
export const showToast = ({
  message,
  title,
  type = 'info',
  icon,
  duration = 3000,
  description,
  showIcon = false,
  ...options
}: ToastConfig) => {
  const Icon = icon || defaultIcons[type]

  const toastOptions: ToastOptions = {
    position: 'top-right',
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  }

  const content = (
    <>
      <div className="flex items-center">
        {showIcon && <Icon className="mr-2" />}
        <span className="font-bold text-primary text-lg">{message || title}</span>
      </div>
      {description && <div>{description}</div>}
    </>
  )

  switch (type) {
    case 'success':
      toast.success(content, toastOptions)
      break
    case 'warning':
      toast.warning(content, toastOptions)
      break
    case 'error':
    case 'validationError':
      toast.error(content, toastOptions)
      break
    default:
      toast.info(content, toastOptions)
  }
}
